import { ApiObjectService } from './api-object.service'

class ZodiacSignService extends ApiObjectService {
    namespace = 'zodiac-signs'
}

export const zodiacSignService = new ZodiacSignService()
